import PropTypes from "prop-types";
import { Carousel } from "components/Carousel";
import { ITXMedia } from "components/ITXMedia";

const GalleryCarouselSettings = {
  draggable: true,
  dots: true,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 4000,
  slidesToShow: 1,
  cssEase: "cubic-bezier(.17,.17,.30,1.00)",
  gap: 0,
  adaptiveHeight: true,
  height: "100%",
  itemHeight: "auto",
  variableWidth: true,
  width: "100%",
  itemWidth: "100%",
  arrows: false,
  nextArrow: null,
  prevArrow: null,
  animation: "scale",
  center: true,
  defaultSlider: 0,
  responsive: {
    breakpoint: 992,
    settings: {
      draggable: true,
      dots: true,
      autoplay: false,
      speed: 1000,
      autoplaySpeed: 4000,
      slidesToShow: 1,
      cssEase: "cubic-bezier(.17,.17,.30,1.00)",
      gap: 0,
      adaptiveHeight: true,
      height: "100%",
      itemHeight: "auto",
      variableWidth: true,
      width: "100%",
      itemWidth: "100%",
      arrows: false,
      nextArrow: null,
      prevArrow: null,
      animation: "scale",
      center: true,
      defaultSlider: 0,
    },
  },
};
/**
 * CarouselDots component
 * @param fields
 * @param lang
 * @returns {JSX.Element}
 * @constructor
 */
export const CarouselDots = ({ fields, lang }) => {
  const { gallery } = fields;

  const renderCarouselDots = () => {
    if (gallery && gallery.length > 0) {
      return (
        <Carousel settings={GalleryCarouselSettings} lang={lang}>
          {gallery.map((item) => {
            const { id, url, name, width, height, type } =
              item.media.staticValue;
            const { caption } = item;
            return type === "Image" ? (
              <figure key={id} className="galleryCarousel__carouselDots__item">
                <ITXMedia
                  id={id}
                  url={url}
                  name={name}
                  width={width || 1024}
                  height={height || 574}
                  alt={caption.staticValue || name}
                  type={type}
                />
                {caption.staticValue ? (
                  <figcaption className={"caption text-center"}>
                    {caption.staticValue}
                  </figcaption>
                ) : null}
              </figure>
            ) : (
              <ITXMedia
                key={id}
                source={url}
                muted
                autoPlay
                loop
                locale={lang}
                type={type}
              />
            );
          })}
        </Carousel>
      );
    } else return null;
  };

  return (
    <div className={"galleryCarousel__carouselDots globalComponentContainer"}>
      {renderCarouselDots()}
    </div>
  );
};

CarouselDots.propTypes = {
  fields: PropTypes.shape({
    gallery: PropTypes.arrayOf(
      PropTypes.shape({
        media: PropTypes.shape({
          staticValue: PropTypes.shape({
            id: PropTypes.string,
            url: PropTypes.string,
            name: PropTypes.string,
            width: PropTypes.number,
            height: PropTypes.number,
            isDark: PropTypes.bool,
            type: PropTypes.oneOf(["Image", "Video", "Document"]),
            fileExtension: PropTypes.string,
          }),
        }),
        caption: PropTypes.shape({
          staticValue: PropTypes.string.isRequired,
        }),
        file: PropTypes.shape({
          staticValue: PropTypes.shape({
            id: PropTypes.string,
            url: PropTypes.string,
            name: PropTypes.string,
            width: PropTypes.number,
            height: PropTypes.number,
            isDark: PropTypes.bool,
            type: PropTypes.oneOf(["Image", "Video", "Document"]),
            fileExtension: PropTypes.string,
          }),
        }),
      }).isRequired
    ),
    carouselType: PropTypes.shape({
      staticValue: PropTypes.arrayOf(
        PropTypes.oneOf([
          "carousel" | "carousel_dots",
          "carousel_arrow",
          "carousel_market",
        ])
      ).isRequired,
    }),
    marginBottom: PropTypes.shape({
      staticValue: PropTypes.arrayOf(
        PropTypes.oneOf([
          "margin__bottom__0",
          "margin__bottom__80",
          "margin__bottom__160",
          "margin__bottom__240",
        ])
      ).isRequired,
    }),
  }).isRequired,
  lang: PropTypes.string.isRequired,
};
